// extracted by mini-css-extract-plugin
export default {"img":"logo_img__9wvxk"};